<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {onMounted, ref, computed} from "vue";
//axios请求
import {inject} from 'vue'
import {ArrowRight} from '@element-plus/icons-vue'

onMounted(() => {
  get_corr()
  get_kme()
});
const $axios = inject('$axios')
const rna_seqList = ref([])
const corrlist = ref([])
const inputText = ref('')
const module = ref('Kmeegg')
const module2 = ref('kmebrown2')
const rna_seqList2 = ref([])
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [5, 10, 20, 50, 100]
// 默认每页显示的条数（可修改）
const PageSize = ref(5)

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function inputInput(e) {
  inputText.value = e.target.value;
  get_kme()
}

const gene1Text = ref('G1004')
const gene2Text = ref('G10013')

function gene1Input(e) {
  gene1Text.value = e.target.value;
}

function gene2Input(e) {
  gene2Text.value = e.target.value;
}


function get_corr() {
  loadtable.value = true
  $axios.get('http://bioinfo-sysu.com:8383/api/get_corr?gene1=' + gene1Text.value + '&gene2=' + gene2Text.value).then((resp) => {
    corrlist.value = resp.data
    loadtable.value = false
  }).catch((err) => {
    console.log(err)
    loadtable.value = false
  })
}

function select1() {
  if (module.value == 'Kmeegg') {
    module2.value = 'kmebrown2'
    get_kme()
  } else {
    module2.value = 'kmeblack'
    get_kme()
  }
}

function get_kme() {
  loadtable1.value = true
  $axios.get('http://bioinfo-sysu.com:8383/api/get_kme?gene=' + inputText.value + '&module=' + module2.value + '&type=' + module.value).then((resp) => {
    rna_seqList.value = resp.data.list
    loadtable1.value = false
  }).catch((err) => {
    console.log(err)
    loadtable1.value = false
  })
}

const sortCorNum = ref(1)

function sortCor() {
  if (sortCorNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortCorNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortCorNum.value = 1
  }
}

const sortPNum = ref(1)

function sortP() {
  if (sortPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortPNum.value = 1
  }
}

const sortAPNum = ref(1)

function sortAP() {
  if (sortAPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortAPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortAPNum.value = 1
  }
}

const loadtable = ref(false)
const loadtable1 = ref(false)

// const downloadFile = (fileName) => {
//   // 文件路径（假设文件名为data.csv）
//   const filePath = './file/' +fileName// 文件位于public目录下
//
//   // 创建隐藏的可下载链接
//   const link = document.createElement('a')
//   link.href = filePath
//   link.download = fileName // 设置下载文件名
//
//   // 添加到DOM并触发点击
//   document.body.appendChild(link)
//   link.click()
//
//   // 清理DOM
//   document.body.removeChild(link)
// };
</script>
<template>
  <div>
    <index-navbar/>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="col-12 my-3">
          <el-breadcrumb :separator-icon="ArrowRight" style="font-size: 22px">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="bi bi-house me-1"></i>Home</el-breadcrumb-item>
            <el-breadcrumb-item>Co-Expression</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="col-12">
          <div class="border-t border-blueGray-200 text-center">
            <div class="flex flex-wrap justify-center">
              <div class="w-full lg:w-9/12 px-4">
                <p class="text-lg leading-relaxed text-blueGray-700">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="col-md-6">-->
        <!--          <img :src="UMAP_celltype">-->
        <!--        </div>-->
        <!--        <div class="col-md-6">-->
        <!--          <img :src="edit_FeaturePlot">-->
        <!--        </div>-->
        <div class="col-12 my-6 ">
          <span class="font-bold">Bulk RNA-seq Pearson correlation：</span>
          <div class="text-center mt-12 d-flex flex-column">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <span>Gene A:</span>
              <input type="text" placeholder="chr14:106539192:CT" @input="gene1Input" :value="gene1Text"
                     class="mx-3 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
              <span>Gene B:</span>
              <input type="text" placeholder="chr14:106539192:CT" @input="gene2Input" :value="gene2Text"
                     class="mx-3 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>

              <button
                  class="mx-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  @click="get_corr">
                Submit
              </button>
            </div>
          </div>
          <table class="table table-striped table-bordered table-md align-middle mt-4"
                 style="text-align: left;table-layout:fixed" v-loading="loadtable">
            <thead>
            <tr>
              <th scope="col" style="width: 20%">Gene A</th>
              <th scope="col" style="width: 20%">Gene B</th>
              <th scope="col" style="width: 20%">Pearson's r</th>
              <th scope="col" style="width: 20%">P value</th>
              <th scope="col" style="width: 20%">n_samples</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.gene1 }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.gene2 }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.pearson_r }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.p_value }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.n_samples }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="d-flex flex-column justify-content-start align-items-start">
              <!--            <button-->
              <!--                class="bg-black text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"-->
              <!--                type="button"-->
              <!--                @click="downloadFile('GSE157007_edit_data.csv')">-->
              <!--              download-->
              <!--            </button>-->
              <div class="d-flex align-items-center mb-3">
                <span class="font-bold">Type:</span>
                <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="module"
                        style="width: 100%; color: #ccc;" @change="select1">
                  <option value="Kmeegg" style="color: black;">kMEegg</option>
                  <option value="Kmehvg" style="color: black;">kMEhvg</option>
                </select>
              </div>
              <div class="d-flex align-items-center">
                <span class="font-bold">Select a module:</span>
                <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="module2"
                        style="width: 50%; color: #ccc;" @change="get_kme">
                  <option value="" disabled selected hidden>Module</option>
                  <option value="kmebrown2" style="color: black;" v-if="module=='Kmeegg'">kMEbrown2</option>
                  <option value="kmebrown4" style="color: black;" v-if="module=='Kmeegg'">kMEbrown4</option>
                  <option value="kmecoral1" style="color: black;" v-if="module=='Kmeegg'">kMEcoral1</option>
                  <option value="kmedarkmagenta" style="color: black;" v-if="module=='Kmeegg'">kMEdarkmagenta</option>
                  <option value="kmedarkolivegreen4" style="color: black;" v-if="module=='Kmeegg'">kMEdarkolivegreen4
                  </option>
                  <option value="kmedarkorange2" style="color: black;" v-if="module=='Kmeegg'">kMEdarkorange2</option>
                  <option value="kmedarkseagreen4" style="color: black;" v-if="module=='Kmeegg'">kMEdarkseagreen4
                  </option>
                  <option value="kmefirebrick4" style="color: black;" v-if="module=='Kmeegg'">kMEfirebrick4</option>
                  <option value="kmegrey" style="color: black;" v-if="module=='Kmeegg'">kMEgrey</option>
                  <option value="kmegrey60" style="color: black;" v-if="module=='Kmeegg'">kMEgrey60</option>
                  <option value="kmeivory" style="color: black;" v-if="module=='Kmeegg'">kMEivory</option>
                  <option value="kmelightcoral" style="color: black;" v-if="module=='Kmeegg'">kMElightcoral</option>
                  <option value="kmemagenta4" style="color: black;" v-if="module=='Kmeegg'">kMEmagenta4</option>
                  <option value="kmenavajowhite1" style="color: black;" v-if="module=='Kmeegg'">kMEnavajowhite1</option>
                  <option value="kmepalevioletred2" style="color: black;" v-if="module=='Kmeegg'">kMEpalevioletred2
                  </option>
                  <option value="kmeplum" style="color: black;" v-if="module=='Kmeegg'">kMEplum</option>
                  <option value="kmeplum1" style="color: black;" v-if="module=='Kmeegg'">kMEplum1</option>
                  <option value="kmesaddlebrown" style="color: black;" v-if="module=='Kmeegg'">kMEsaddlebrown</option>
                  <option value="kmeskyblue2" style="color: black;" v-if="module=='Kmeegg'">kMEskyblue2</option>
                  <option value="kmeblack" style="color: black;" v-if="module=='Kmehvg'">kMEblack</option>
                  <option value="kmeblue" style="color: black;" v-if="module=='Kmehvg'">kMEblue</option>
                  <option value="kmebrown" style="color: black;" v-if="module=='Kmehvg'">kMEbrown</option>
                  <option value="kmegreen" style="color: black;" v-if="module=='Kmehvg'">kMEgreen</option>
                  <option value="kmegreenyellow" style="color: black;" v-if="module=='Kmehvg'">kMEgreenyellow</option>
                  <option value="kmemagenta" style="color: black;" v-if="module=='Kmehvg'">kMEmagenta</option>
                  <option value="kmepink" style="color: black;" v-if="module=='Kmehvg'">kMEpink</option>
                  <option value="kmepurple" style="color: black;" v-if="module=='Kmehvg'">kMEpurple</option>
                  <option value="kmered" style="color: black;" v-if="module=='Kmehvg'">kMEred</option>
                  <option value="kmesalmon" style="color: black;" v-if="module=='Kmehvg'">kMEsalmon</option>
                  <option value="kmeturquoise" style="color: black;" v-if="module=='Kmehvg'">kMEturquoise</option>
                  <option value="kmeyellow" style="color: black;" v-if="module=='Kmehvg'">kMEyellow</option>
                </select>
              </div>
              <table class="table table-striped table-bordered table-md align-middle mt-4"
                     style="text-align: left;table-layout:fixed" v-loading="loadtable1">
                <thead>
                <tr>
                  <th scope="col" style="width: 35%">Module</th>
                  <th scope="col" style="width: 30%">Gene</th>
                  <th scope="col" style="width: 35%">kME value</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    <input type="text" placeholder="Search Gene ID" @input="inputInput" :value="inputText"
                           class="w-full placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
                  </td>
                </tr>
                <tr v-for="(item,index) in rna_seqList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{ module2 }}
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    <router-link
                        :to="{name:'genedetail',query:{gene:item.geneid}}">
                      <el-link>{{ item.geneid }}</el-link>
                    </router-link>
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{ item[Object.keys(item)[1]] }}
                  </td>
                </tr>
                </tbody>
              </table>
              <!--    分页操作-->
              <div class="pagination-container">
                <el-pagination
                    class="el-pager mt-3"
                    style="--el-color-primary:#303034"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="pageSizes"
                    :page-size="PageSize"
                    layout="prev, pager, next"
                    :total="rna_seqList.length">
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="col-8">
            <div class="d-flex flex-row justify-content-start align-items-center">
              <img src="@/assets/pic/traitegg.png" v-if="module=='Kmeegg'">
              <img src="@/assets/pic/traithvg.png" v-if="module=='Kmehvg'">
            </div>
          </div>
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
<style scoped>
.pagination-container {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
</style>